const en_US = {
	translation: {
		"SuccessChangesSaved": "Your changes have been saved",
		"ErrorValuesNotValid": "Some values are not valid",
		"LabelSettings": "Settings",
		"LabelConfigureApplication": "Configure your application",
		"ButtonTutorial": "TUTORIAL",
		"ButtonPublish": "PUBLISH",
		"ButtonLiveView": "LIVE VIEW",
		"ButtonSaveChanges": "SAVE CHANGES",
		"ButtonAddMenuItem": "ADD MENU ITEM",
		"ButtonReset": "RESET",
		"ButtonResetSettings": "RESET SETTINGS",
		"ButtonOk": "OK",
		"ButtonRemove": "REMOVE",
		"ButtonResetCertificates": "RESET CERTIFICATES SETTINGS",
		"LabelMain": "Settings",
		"LabelInfo": "General",
		"LabelAssets": "Assets",
		"LabelIos": "Android # iOS",
		"LabelAndroid": "Android",
		"LabelServices": "Services",
		"LabelMenu": "Menu",

		"LabelWelcome": "Welcome",
		"LabelWelcome0": "Congratulations, your app is ready!! Do you want to try it?",
		"LabelWelcome1": "1) Install the MyLiveViewer test app on your device, available in Stores",
		"LabelWelcome2": "2) Press the LIVE VIEW button at the top of this page: a QR Code will appear",
		"LabelWelcome3": "3) Launch the MyLiveViewer app on your device and scan the newly generated QR Code",
		"LabelWelcome4": "Now preview your app to see how it will look when it is published on the Stores",
		"LabelWelcome5": "You can find a full tutorial here:",

		"LabelHints": "Help",

		"LabelSettings": "Reset",
		"LabelUploadHelp": "Drop files here or click here to browse your files",
		"LabelUploadFile": "UPLOAD FILE",
		"LabelSplashScreen": "Splash screen .png (suggested size 1152px X 2046px) *",
		"LabelAppIcon": "App icon .png (suggested size 1024px X 1024px)*",
		"LabelMenuHeaderBackground": "Menu header Background .png (suggested size 300px X 200px)",
		"LabeliOSBuildEnabled": "Build for iOS enabled",

		"LabeliOSBuildHelpUrl": "documents/iOS-Hints-en_EN.html",

		"LabeliOSP12CertificateFile": "Upload a .p12 certificate *",
		"LabeliOSP8CertificateFile": "Upload a .p8 certificate *",
		"LabeliOSCertificatePassword": "Certificate password  *",
		"HelperiOSCertificatePassword": "The password used to protect the certificate",
		"LabeliOSMobileProvisionFile": "Upload a .mobileprovision file *",
		"LabelAppTitle": "App Title *",
		"HelperAppTitle": "This title will be shown in the app top navigation bar",
		"LabelMenuTitle": "Menu Title",
		"HelperMenuTitle": "This title will be shown on the header of the native app side menu",
		"LabelBundleId": "Bundle Id *",
		"HelperBundleId": "Uniquely identifies an application on the stores, use reverse domain name notation like 'com.yourdomain.appName' ",
		"LabelVersionNumber": "Version number *",
		"HelperVersionNumber": "This identify the app version on the stores, use standard version notation like '1.0' ",
		"LabelShareAppIos": "iOS Share Button Text",
		"HelperShareAppIos": "Text used as body in the message sent when using the screen share app feature",
		"LabelShareAppAndroid": "Android Share Button Text",
		"HelperShareAppAndroid": "Text used as body in the message sent when using the screen share app feature",
		"LabelUseNativeAppSideMenu": "Use native app side menu",
		"HelperUseNativeAppSideMenu": "Enable or disable the native navigation menu in the app",
		"LabelAppPrimaryColor": "App Primary Color",
		"LabelAppSecondaryColor": "App Secondary Color",
		"LabelAppTitleColor": "App Title Color",
		"LabelMenuBackgroundColor": "Menu Background Color",
		"LabelColorHeaderMenu": "Menu Title Text Color",
		"LabelMenuTitleBackgroundColor": "Menu Title Background Color",
		"LabelMenuItemsTextColor": "Menu Items Text Color",
		"LabelOneSignalAppId": "OneSignal App ID",
		"HelperOneSignalAppId": "Add your OneSignal App ID to enable push notifications",
		"LabelSendGripApiKey": "SendGrip Api Key",
		"HelperSendGripApiKey": "Add your SendGrid API Key to enable emails templates functionality",
		"LabelBackgroundColor": "Background color",
		"LabelTitle": "Title",
		"LabelTextColor": "Text Color",
		"LabelFontSize": "Font Size",
		"LabelFontStyle": "Font Style",
		"LabelTargetPlatform": "Enabled on devices",
		"LabelVisible": "Visible",
		"LabelDeleting": "Deleting",
		"LabelDeleteConfirmQuestion": "Are you sure to delete this menu item?",
		"ButtonCancel": "CANCEL",
		"ButtonDelete": "DELETE",
		"ButtonClose": "CLOSE",
		"ButtonBack": "BACK",
		"ButtonNext": "NEXT",
		"ButtonGenerate": "GENERATE",
		"LabelAndroidBuildEnabled": "Build for Android enabled",

		"LabelAndroidBuildHelpUrl": "documents/Android-Hints-en_EN.html",

		"LabelAndroidKeyStoreFile": "Upload a .keystore certificate *",
		"LabelAndroidKeyStoreAlias": "Keystore Alias *",
		"HelperAndroidKeyStoreAlias": "Alias entry in the .keystore file",
		"LabelAndroidKeyStorePassword": "Certificate Password *",
		"HelperAndroidKeyStorePassword": "The password used to protect the certificate",
		"LabelLinkType": "Link Type",
		"LabelUrl": "URL",
		"LabelLink": "Link",
		"LabelPhoneNumber": "Phone number",
		"LabelThickness": "Thickness",
		"LabelQrUrl": "Send QR code content to this URL",
		"LabelEmail": "Email",
		"LabelTemplateId": "Template Id",
		"LabelIconPickerText": "Pick an icon",
		"LabelBuilds": "Builds",
		"LabelDownloadYourBuilds": "DOWNLOAD YOUR BUILDS",
		"LabelBuildName": "NAME",
		"LabelBuildDeviceType": "DEVICE TYPE",
		"LabelBuildStatus": "STATUS",
		"LabelBuildDate": "BUILT ON",
		"LabelBuildActions": "ACTIONS",
		"LabelBuildDownload": "Download",
		"LabelBuildRedo": "Retry this build",
		"LabelBuildCancel": "Cancel this build",
		"LabelBuildDelete": "Delete this build",
		"LabelBuildCompleted": "Completed",
		"LabelBuildNotStarted": "Not Started",
		"LabelBuildInProgress": "In Progress",
		"LabelBuildCancelling": "Cancelling",
		"LabelBuildCanceled": "Canceled",
		"LabelBuildUnknown": "Unknown",
		"LabelBuildFailed": "Failed",
		"LabelBuildError": "Error",
		"LabelNoMenuItems": "No menu items defined",
		"LabelJsonUrl": "URL of the JSON",
		"LabelMenuItemsBackgroundColor": "Menu Items Background Color",
		"MessageWrongFileSize5": "Invalid image, maximum size allowed is 5mb",
		"MessageWrongFileSize1": "Invalid image, maximum size allowed is 1mb",
		"MessageWrongImageFormat": "Invalid image format, only .PNG is supported",
		"MessageiOSInvalidP12File": "Invalid file format, only .p12 is supported",
		"MessageiOSInvalidP8File": "Invalid file format, only .p8 is supported",
		"MessageiOSInvalidPPFile": "Invalid file format, only .mobileprovision is supported",
		"MessageAndroidInvalidKSFile": "Invalid file format, only .keystore is supported",
		"MessageFileUploadOk": "Your file has been uploaded correctly",
		"SuccessLiveConfigUpdate": "Live view configuration updated",
		"ErrorLiveConfigUpdate": "Unable to update live view configuration",
		"SuccessAppConfigUpdate": "App configuration published",
		"ErrorAppConfigUpdate": "Unable to publish app configuration",
		"LabelUserLivewViewer": "Scan this QR code using the MyLiveViewer application",
		"LabelLivewViewerQrError": "We are sorry but we were unable to generate the QR code, please try later :(",
		"UrlGooglePlayBadge": "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png",
		"UrlAppStoreBadge": "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1605830400&h=cf9c84bebcfeb0d6ebe208e22e464a23",
		"LabelChangesAreMade": "You have unsaved changes to your configuration — save them in order to update the live view or to publish them",
		"ButtonCreateBuild": "CREATE BUILD",
		"ButtonBuyLicense": "BUY",
		"LabelLicenseNotFound": "Your license is expired or not valid — please buy one to build your application and publish the configuration",
		"LabelLiveConfigNotUpdated": "Live view configuration is not up to date — consider to update the live view configuration in order to make it available to the live viewer",
		"LabelAppConfigNotUpdated": "App configuration is not up to date — consider to publish it in order to make it available to any app builds",
		"DialogPublish": "Publish Configuration",
		"LabelConfirmPublishConfig": "Do you want to publish the app configuration? When you publish the configuration all app builds will use this version.",
		"DialogBuildApp": "Create a Build",
		"LabelCantBuildiOS": "iOS build is not available — please fill the iOS configuration tab",
		"LabelCantBuildAndroid": "Android build is not available — please fill the Android configuration tab",
		"LabelCantBuildAnyPlatform": "Building is not available - please enable and fill the iOS and/or the Android configuration tab",
		"LabelCanBuildiOS": "iOS build is available — creating a build will generate a new app bundle to download",
		"LabelCanBuildAndroid": "Android build is available — creating a build will generate a new app bundle to download",
		"ButtonRefresh": "Refresh",
		"LabelMigrate": "Migrate",
		"LabelMigrateOldConfig": "Migrate old configuration",
		"LabelPageNotFound": "404: The page you are looking for isn’t here",
		"LabelShadyPath": "You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation",
		"ButtonMigrate": "Migrate",
		"LabelMigrationNeeded": "Migration Needed",
		"LabelMigrationExplained": "This plugin version is not compatibile with the current configuration of your app. You need to update it, but fear not, the procedure is automatically done for you!",
		"ButtonMigrateNow": "Click here to begin the migration",
		"MessageMigrationOk": "Configuration migrated successfully",
		"LabelHomeUrl": "Home URL",
		"HelperHomeUrl": "Specify the url of the home page",
		"LabelSelectPage": "Select page",
		"TitleUploadOverlayImages": "Upload overlay images",
		"TitleUploadScenarioImages": "Upload scenario images",
		"ButtonUploadOverlay": "Upload Overlay",
		"ButtonUploadScenario": "Upload Scenario",
		"LabelImageSource": "Images Source",
		"LabelHelpPageLinkType": "Help Page Link Type",
		"LabelHelpPageLink": "Link Help Page",
		"LabelMode": "Mode",
		"LabelSelectHelpPage": "Select Help Page",
		"LabelMigrationFailed": "We are terribly sorry but something went wrong, you can retry the migration operation or skip it (old seetings will be lost)",
		"ButtonStartFromScratch": "START FROM SCRATCH",
		"LabelNoAppConfigToBuild": "App configuration is not published — you need to publish it to build your application",
		"LabelBuildIsInProgress": "Perparing application bundle for build operations...",
		"LabelDownloadIsInProgress": "Preparing application bundle to download...",

		"LabelGenericError": "Something went wrong",
		"LabelGenericErrorMessage": "A glitch in the system or the matrix was reloading, please try again!",

		"LabelNoHttpError": "No HTTPS protocol detected",
		"LabelNoHttpErrorMessage": "Your site must be hosted using HTTPS as protocol",

		"LabelNoLocalError": "On line site needed",
		"LabelNoLocalErrorMessage": "Your site needs to be online, sorry!",

		"LabelCertWizardTitle": "Certificates Configuration",
		"LabelStep": "Step",
		"LabelOf": "Of",
		"LabelCertWizardHelpTitle": "Getting lost or no clue of what you need here?",
		"ButtonStartWizard": "START WIZARD",
		"LabelCertWizardBundleId": "To enable the guided procedure you need first to set the <strong>Bundle Id</strong> setting in the <strong>Info</strong> tab.",

		"HelperAppleDevEmail": "Use your developer account Apple ID",
		"HelperAppleDevIssuerId": "Use your developer account Issuer ID found in the AppStore Connect console",
		"HelperAppleDevKeyId": "Use the key ID generated in the AppStore Connect console",
		"HelperAppleDevTokenFile": "Upload the .p8 certificate generated in the AppStore Connect console",

		"LabeliOSCertWizardWizardHint": "Follow the wizard to generate a <strong>.p12</strong> certificate and a <strong>.mobileprovision</strong> file.<br /><br >To generate keys, you must have an Admin account in App Store Connect.<br /><br />Click <a target='blank' href='https://developer.apple.com/documentation/appstoreconnectapi/creating_api_keys_for_app_store_connect_api'>here</a> for a complete guide on how to create these values.",
		"LabeliOSCertWizardHelpBody": `
			<br />
			To build your <strong>iOS</strong> application you need a <strong>.p12</strong> certificate and a <strong>.mobileprovision</strong> file. You can manually upload them or in case your need more help,
			just press the START WIZARD button to begin a guided procedure which will help you to setup this configuration section in no time!
			<br />
			<br />
			The steps to complete this operation are really easy but you are required to have valid <strong>Apple</strong> developer account to build and publish your application on the store.
			<br />
			<br />
			In case you need to to register a new <strong>Apple</strong> develoepr account please <a href="https://developer.apple.com/programs/" target="_blank">visit the official site</a>
			<br />
			<br />
		`,

		"HelperAndroidDevEmail": "Use your developer account Google ID",
		"HelperAndroidDevKSAlias": "Enter an identifying name for your key",

		"LabelAndroidCertWizardWizardHint": "Follow the wizard to generate a <strong>.keystore</strong> certificate.<br /><br />Click <a target='blank' href='https://developer.android.com/studio/publish/app-signing'>here</a> for a complete guide about these values.",
		"LabelAndroidCertWizardHelpBody": `
			<br />
			To build your <strong>Android</strong> application you need a <strong>.keystore</strong> certificate. You can manually upload it or in case your need more help,
			just press the START WIZARD button to begin a guided procedure which will help you to setup this configuration section in no time!
			<br />
			<br />
			The steps to complete this operation are really easy but you are required to have valid <strong>Google</strong> developer account to publish your application on the store.
			<br />
			<br />
			In case you need to to register a new <strong>Google</strong> develoepr account please <a href="https://play.google.com/console/about/" target="_blank">visit the official site</a>
			<br />
			<br />
		`,

		"LabelResetSettings": "Reset all settings",
		"LabelResetSettingsHelp": "Delete the plugin current configuration, reverting all the settings to the default value. Warning, this operation is destructive and can't be undone.",
		"DialogResetSettings": "Reset Settings",
		"LabelConfirmSettingsReset": "Do you really want to delete the current configuration? All the settings will be lost and cannot be recovered.",

		"LabelDrawerMenuLayout": "Use a drawer navigation menu layout",
		"LabelTilesMenuLayout": "Use a tiled navigation menu layout",
		"LabelTabsMenuLayout": "Use a tabbed navigation menu layout",

		"LabelUseLightStatusBar": "Use light content status bar",
		"HelperUseLightStatusBar": "Enable this when you set a DARK color for your app primary color",

		"LabelUseUserLogin": "Use user login",
		"HelperUseUserLogin": "Enable this when you want to use the user login to access your app",

		"LabelLoginAlways": "Always show a login screen to access the application",
		"LabelLoginAction": "Show a login screen only when a menu action is triggered",
		"LabelLoginCode": "Show a login screen only when invoked via javascript bridge",

		"LabelEntryTextColor": "Entry Text Color",
		"LabelEntryBackgroundColor": "Entry Background Color",
		"LabelErrorTextColor": "Error Text Color",

		"LabelUseAllCategories": "Use all categories",
		"HelperUseAllCategories": "Enable this when you want to show all the categories in your list",
		"LabelSelectCategory": "Select Category",

		"LabelPostLayoutOneColumnPWT": "Post list layout will be one column with picture and title",
		"LabelPostLayoutOneColumnPWD": "Post list layout will be one column with picture and details",
		"LabelPostLayoutTwoColumnsPWT": "Post list layout will be two columns with picture and title",

		"LabelInfoGeneral": "General",
		"LabelInfoSharing": "Sharing",
		"LabelInfoAuthentication": "Authentication",
		"LabelInfoMenuAndNavigation": "Navigation",
		"LabelInfoStyleAndAppearance": "Appearance",

		"LabelProtected": "Only logged in users can access this content",
		"LabelAllowShareWebView": "Enable the user to share the content of this webview",

		"LabelLoginPage": "Login Page .png (suggested size 1152px X 2046px) *",

		"LabelBackgroundImage": "Background Image",
		"ButtonRemoveBkgImage": "Remove background image",

		"LabelHideIcon": "Hide the icon for this menu item",
		"LabelHideTitle": "Hide the title for this menu item",

		"LabelLicenseId": "License ID",
		"HelperLicenseId": "Use this value when purchasing My FastAPP license for this site",

		"LabelPreparingBuildDownload": "Preparing download for",

		"MenuItemHomePage": "Home Page",
		"MenuItemBusinessCard": "Business Card",
		"MenuItemMailTo": "Send Email",
		"MenuItemEmptyLine": "Empty Line",
		"MenuItemOpenURL": "Open URL",
		"MenuItemPhoneCall": "Phone Call",
		"MenuItemPhotoEditor": "Photo Editor",
		"MenuItemPhotoSend": "Send Photo",
		"MenuItemQR": "QR",
		"MenuItemSeparator": "Separator",
		"MenuItemSendSms": "Send SMS",
		"MenuItemOnLineWebView": "Web View",
		"MenuItemPostList": "Post List",
		"MissingHomePageError": "A menu item of type '$type' is missing",

		"YupValueRequired": "A value is required",
		"YupTitleRequired": "A title is required",
		"YupFileRequired": "A file is required",
		"YupLinkRequired": "A link is required",
		"YupPhoneNumberRequired": "A phone number is required",
		"YupTemplateIdRequired": "A template ID is required",
		"YupEmailRequired": "An email address is required",
		"YupValidEmailRequired": "Must be a valid email address",
		"YupUrlRequired": "An url is required",
		"YupValidUrlRequired": "Must be a valid URL",
		"YupInvalidBundleId": "Bundle id is not correct, only: letters, nubmers, dots and underscores are allowed"
	}
};
export default en_US;